import { isNull } from './isNull';

export const isObject = (value: unknown): value is object =>
    typeof value === 'object' && !Array.isArray(value) && !isNull(value);
